export default __webpack_public_path__ + "static/media/icon-edit-profile.710252b9.svg";